import { render, staticRenderFns } from "./customDashboardEntityFilter.vue?vue&type=template&id=5fa40dcf"
import script from "./customDashboardEntityFilter.vue?vue&type=script&lang=js"
export * from "./customDashboardEntityFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports